import { type ReactNode } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { CardControlsContainer } from '../../CardControlsContainer';
import { CardPublisherContainer } from '../../CardPublisherContainer/CardPublisherContainer';
import { PublicationDateContainer } from '../../PublicationDateContainer';
import { PublisherDesktopLayout } from '../components/PublisherDesktopLayout';

export function PublisherContainer(): ReactNode {
  const isNarrow = useListingLayoutIsNarrowSelector();

  if (isNarrow) {
    return null;
  }

  return (
    <PublisherDesktopLayout
      controls={<CardControlsContainer />}
      publicationDate={<PublicationDateContainer />}
      publisher={<CardPublisherContainer />}
    />
  );
}
